import dayjs from 'dayjs'
import { LanguageCodes } from '../configuration/constants/enums'

const setLocale = async (languageCode: LanguageCodes): Promise<void> => {
  switch (languageCode) {
    case LanguageCodes.SPANISH:
      await import('dayjs/locale/es')
      dayjs.locale('es')
      return
    default:
      return
  }
}

export default setLocale
